'use client';

import React from 'react';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import Checkbox from '@dealroadshow/uikit-checkbox';
import IconClose from '@dealroadshow/uikit-icon/IconClose';
import { useCookiesBannerContext } from './CookiesBannerContext';

import staticUrls from '@framework/url/staticUrls';

import styles from './cookiesBanner.module.scss';

/**
 * @deprecated This component has been chosen for migration to UIKit, meaning any further changes or updates
 * must be completed within the migration process.
 * @see https://www.notion.so/finsight-group/Component-Migration-Process-f4475950481d429ba0dc450d0bb0cb8b
 */
const CookiesBanner = () => {
  const {
    isMarketingAccepted,
    isManageCookiesOpen,
    isBannerVisible,
    onMarketingChange,
    openCookiesSettings,
    closeBanner,
    saveSettings,
    saveAll,
  } = useCookiesBannerContext();

  if (!isBannerVisible) {
    return null;
  }
  return (
    <div className={ styles.cookiesBannerWrapper }>
      <IconClose
        className={ styles.cookiesBannerClose }
        onClick={ closeBanner }
        data-test="closeCookieBannerIcon"
      />
      <div className={ styles.cookiesBannerContent }>
        <div className={ styles.cookiesBannerText }>
          We use functional cookies to make this site work properly and marketing cookies to personalize content.
          By continuing or clicking { isManageCookiesOpen ? '"Save"' : '"Ok"' }, you consent to our use of cookies. See our&nbsp;
          <a
            className={ styles.cookiesBannerLink }
            href={ `${ staticUrls.getPrivacyPolicyUrl() }#cookiesPolicy` }
            target="_blank"
          >
            Cookie Policy
          </a>&nbsp;for more information.
          <div>
            By continuing, you agree to FINSIGHT's&nbsp;
            <a
              className={ styles.cookiesBannerLink }
              href={ `${ staticUrls.getTermsOfUseUrl() }` }
              target="_blank"
            >
              Terms of Use
            </a>
            { ' and ' }
            <a
              className={ styles.cookiesBannerLink }
              href={ `${ staticUrls.getPrivacyPolicyUrl() }` }
              target="_blank"
            >Privacy Policy
            </a>.
          </div>
        </div>
        <Button
          variant={ ButtonVariantType.action }
          dataTest={ isManageCookiesOpen ? 'saveCookiesSettings' : 'agreeWithCookiesBtn' }
          onClick={ isManageCookiesOpen ? saveSettings : saveAll }
          className={ styles.cookiesBannerBtn }
          title={ isManageCookiesOpen ? 'Save' : 'Ok' }
        />
        <div className={ styles.cookiesManageBlock }>
          { !isManageCookiesOpen ? (
            <Button
              variant={ ButtonVariantType.outline }
              dataTest="manageCookiesBtn"
              onClick={ openCookiesSettings }
              className={ styles.cookiesBannerManageBtn }
            >
              Manage
            </Button>
          ) : (
            <div className={ styles.cookiesCheckboxes }>
              <Checkbox
                dataTest="functionalCookiesAccept"
                label="Functional"
                disabled
                checked
                className={ styles.functionalCheckbox }
              />
              <Checkbox
                dataTest="marketingCookiesAccept"
                label={ <label className={ styles.marketingLabel }>Marketing</label> }
                onChange={ onMarketingChange }
                checked={ isMarketingAccepted }
                className={ styles.marketingCheckbox }
              />
            </div>
          ) }
        </div>
      </div>
    </div>
  );
};

export default CookiesBanner;
